import {queryEnumDetailByCode} from "@/main-page/servers/formPageServer";
import {loadDomainList, loadListByUrl} from "@/api/domainApi/domainComApi";
import {deepClone, GoingNewUtils} from "xmgoing-utils";
import {UsersFactory} from "@/main-page/utils/UsersFactory";
import {initQueryParamsObj} from "@/main-page/utils/domainQueryUtils";

export enum CommonEnum {

  CURRENT_DATE = 'currentDate',
  CURRENT_DATE_TIME = 'currentDateTime',
  CURRENT_START_TIME = 'currentStartTime',
  CURRENT_END_TIME = 'currentEndTime',
  RECENTLY_3 = 'recently3',
  RECENTLY_5 = 'recently5',
  RECENTLY_10 = 'recently10',

  WEILAI_one = 'oneWeiLaiDate',
  WEILAI_two = 'twoWeiLaiDate',
  WEILAI_three = 'threeWeiLaiDate',
  WEILAI_seven = 'sevenWeiLaiDate',
  THIRTH_seven = 'thrithDate',

  RECENTLY_M_3 = 'recentlyMonth3',
  RECENTLY_M_6 = 'recentlyMonth6',
  RECENTLY_M_12 = 'recentlyMonth12',

  RECENTLY_D_3 = 'recentlyDay3',
  RECENTLY_D_4 = 'recentlyDay4',
  RECENTLY_D_7 = 'recentlyDay7',
  RECENTLY_D_15 = 'recentlyDay15',
  RECENTLY_D_30 = 'recentlyDay30',


  CURRENT_TIME = 'currentTime',
  CURRENT_YEAR = 'curYear',
  PRE_YEAR = 'preYear',

  CURRENT_MONTH = 'curMonth',
  PRE_MONTH = 'preMonth',

  CURRENT_USER = 'currentUser',
  TENANT_NAME = 'tenantName',
  TENANT_NAME_ID= 'tenantId',
  CURRENT_USER_ID = 'currentUserId',
  CURRENT_USER_NO = 'currentUserNo',
  CURRENT_ORG_ID = 'currentOrgId',
  CURRENT_ORG = 'currentOrg',
  UUID = 'uuid',


  CTL_USER_SELECT = 'UserSelect',
  CTL_DEPARTMENT_SELECT = 'DepartmentSelect',
}
interface IDataConfig{
  url:string;
  defReadCol:string;
  wirteTargetObj:string;
  useQueryUrl?:string;
}

export const getUrlStr=function (dataConfig){
  if(unref(dataConfig).queryUserParams){
    return (dataConfig.url||dataConfig.useQueryUrl)+JSON.stringify(unref(dataConfig).queryUserParams)
  }else{
    return (dataConfig.url||dataConfig.useQueryUrl);
  }
}
class EnumFactory extends UsersFactory{
  dsQueue: any;
  queryQueue: any;
  enumValFact: any;
  datas:any;
  cellType:string;
  refObjList: any;
  addLoadingQueue:any;
  cellMapRelObj:any;


  constructor() {
    super();
    this.datas={};
    this.dsQueue = {};
    this.cellType='';
    this.addLoadingQueue={};
    this.cellMapRelObj={};

    this.queryQueue = {};
    this.enumValFact = {};
    this.refObjList = {};
  }

  //添加到队列
  addEnumQueryQueue({enumCode, enumShowVal}) {
    if (this.queryQueue[enumCode] == null) {
      this.queryQueue[enumCode] = enumCode;
      this.executeQuery(enumCode, enumShowVal);
    } else {
      if (this.refObjList[enumCode] == null) {
        this.refObjList[enumCode] = [];
      }
      this.refObjList[enumCode].push(enumShowVal);
    }
  }

  /**
   * 加载完成了 则循环其他等待翻译的列表
   * @param enumCode
   */
  setEnumCodeListValue(enumCode) {
    if (this.refObjList[enumCode] && Array.isArray(this.refObjList[enumCode])) {
      this.refObjList[enumCode].forEach((enumShowValNew) => {
        this.getEnumShowVal(enumCode, enumShowValNew);
      })
    }
  }


  addCellMapQueue(enumShowVal, dataConfig:IDataConfig) {
    if (dataConfig && getUrlStr(dataConfig)) {
      this.dsQueue[getUrlStr(dataConfig)] = dataConfig;
      if(this.cellMapRelObj[getUrlStr(dataConfig)]){
        this.cellMapRelObj[getUrlStr(dataConfig)].push(enumShowVal);
      }else{
        this.cellMapRelObj[getUrlStr(dataConfig)]=[enumShowVal];
      }
    }
  }

  afterLoadData(datas,dataConfig){
    delete this.addLoadingQueue[getUrlStr(dataConfig)];
    const showContentMap={};
    if(datas&&datas.records){
      this.datas[getUrlStr(dataConfig)]=datas.records;
      datas.records.forEach((recordDb)=>{
        if(recordDb[dataConfig['defReadCol']]){
          showContentMap[(recordDb[dataConfig['defReadCol']]+'')]=recordDb[dataConfig['wirteTargetObj']];
        }else{
          if(dataConfig['showCols']&&dataConfig['showCols']['labelCol']){
            showContentMap[(recordDb['id']+'')]=recordDb[dataConfig['showCols']['labelCol']['columnName']];
          }else{
            if(dataConfig.titleId&&dataConfig.titleId[0]){
              showContentMap[(recordDb[dataConfig.keyId]+'')]=recordDb[dataConfig.titleId[0]];
            }else{
              showContentMap[(recordDb['id']+'')]=recordDb[dataConfig['wirteTargetObj']];
            }
          }
        }
      })
    }
    this.cellMapRelObj[getUrlStr(dataConfig)].forEach((showValCell:any)=>{
      if(unref(showValCell)&&typeof unref(showValCell)==='object'&&Object.keys(unref(showValCell)).length>0){
        Object.keys(unref(showValCell)).forEach((propName)=>{
          unref(showValCell)[propName]=showContentMap[unref(propName)+''];
        })
        return
      }

      if(showContentMap[unref(showValCell)+'']){
        showValCell.value=showContentMap[unref(showValCell)+''];
      }else{
        if(showValCell.value){
          if('xmDataRelCell'===this.cellType){
            showValCell.value=GoingNewUtils.getUUChar(20);
          }
        }else{
          showValCell=unref(showValCell);
        }
      }
    })
  }
  /**
   * 加载到loading列表中
   * @param dataConfig
   */
  async addToLoadingQueueList(dataConfig,pageModelsStore,extendParams={}){
    this.addLoadingQueue[getUrlStr(dataConfig)]=true;
   if ((unref(dataConfig).queryUrl || unref(dataConfig).userDefUrl)) {
     const queryParams = {};
     //组装查询条件
     const queryParamsDs = deepClone(unref(dataConfig).queryUserParams);
     if (queryParamsDs && Array.isArray(queryParamsDs)) {
       queryParamsDs.forEach((itemDb) => {
         initQueryParamsObj(itemDb,pageModelsStore,queryParams);
       })
     }
     if (unref(dataConfig).lccQueryScopeType&&unref(dataConfig).lccQueryScopeType!=='currentAccount') {
       queryParams['lccQueryScopeType'] = unref(dataConfig).lccQueryScopeType;
     }
      //根据指定查询url进行查询
     const datas = await loadListByUrl({
       queryParams: {...extendParams,...queryParams,size: 9999},
       url: unref(dataConfig).useQueryUrl,
       method:unref(dataConfig).useQueryType||"GET",
       current: unref(1)
     });

     if(datas&&Array.isArray(datas)){
       this.afterLoadData({records:datas},dataConfig)
     }else if(datas&&datas.records&&Array.isArray(datas.records)){
       this.afterLoadData(datas,dataConfig)
     }
     return;
    }
    const datas = await loadDomainList({
      ...extendParams,
      lccQueryScopeType:unref(dataConfig).lccQueryScopeType,
      pageCode: unref(dataConfig).domainCode,
      pageSize: GoingNewUtils.maxPageSize,
    });
    this.afterLoadData(datas,dataConfig)
  }


  /**
   * 查询数据
   */
  queryDs(pageModelsStore,extendParams){
     Object.keys(this.dsQueue).forEach((url)=>{
       if(this.addLoadingQueue[url]!==true){
         this.addToLoadingQueueList(this.dsQueue[url],pageModelsStore,extendParams);
       }
     })
  }

  /**
   * 获取枚举显示
   * @param enumCode
   * @param enumShowVal
   */
  getEnumShowVal(enumCode, enumShowVal) {
    const showTempVal = unref(enumShowVal);
    //从缓存中获取 枚举集合
    const enumMap = this.enumValFact[enumCode];
    //如果缓存不存在
    if (enumMap == null) {
      this.addEnumQueryQueue({enumCode, enumShowVal});
    } else {
      //如果缓存存在了
      const relItem = enumMap.filter((itemDb) => {
        return itemDb.value === unref(showTempVal);
      })[0]
      if (relItem) {
        enumShowVal.value = relItem['label'];
      }
    }
  }

  //执行查询操作
  executeQuery(enumCode, enumShowVal) {
    queryEnumDetailByCode({
      enumCode, backFun: (res) => {
        const options:any = [];
        if (res && Array.isArray(res)) {
          res.forEach((record: any) => {
            unref(options).push({label: record.name, value: record.value})
          })
        }
        this.enumValFact[enumCode] = options;
        this.getEnumShowVal(enumCode, enumShowVal);
        this.setEnumCodeListValue(enumCode);
      }
    });
  }



}

const enumFactory = new EnumFactory();

export default enumFactory;
